/* eslint-disable import/prefer-default-export */
/* eslint-disable import/extensions */
import { brand } from 'config';
import ExpandableListC from './ExpandableList.vue';
import ExpandableListEmptyC from './ExpandableListEmpty.vue';

export const ExpandableList = brand === 'mcom' ? ExpandableListC : ExpandableListEmptyC;
